<div class="workspace no-back-btn infl-review-container" >
  <achoo-placeholder [placeholderId]="'InfluencerReviewLoading'" [normalPlaceholder]="true" [isFullscreenLoader]="false">
    <div class="influencer-review" *ngIf="pendingInfluencer">
      <div class="ir-header">
        {{'pending_influencer.influencer_count' | translate:{influencer_count:totalPendingInfluencer} }} ({{'pending_influencer.campaign_influencer_count' | translate:{campaign_influencer_count:numberOfPendingInfluencersInCampaign} }})
      </div>
      <div class="ir-body">
        <div class="ir-title row">
          <div class="col-md-3">{{'pending_influencer.influencer' | translate:{id: pendingInfluencer.id} }}</div>
          <div class="col-md-6" *ngIf="pendingInfluencer.activeCampaigns?.length > 0">
            {{'pending_influencer.campaign' | translate:{campaign_name:pendingInfluencer.activeCampaigns[0].name} }} ({{pendingInfluencer.activeCampaigns[0].id}} - {{pendingInfluencer.activeCampaigns[0].companyId}})
          </div>
          <div class="col-md-3 ir-note">
            <span *ngIf="pendingInfluencer.addedType==3">{{'influencer_type.user_added' | translate}}</span> 
            <span *ngIf="pendingInfluencer.addedType==5">{{'influencer_type.group_discover_added' | translate}}</span> 
            <span *ngIf="pendingInfluencer.createdAt"> - {{pendingInfluencer.createdAt | date:'MMM dd, yyyy'}}</span>
          </div>
        </div>
        <div class="pending-influencer-container">
          <form class="pending-influencer-form" [ngClass]="{'has-error': hasFieldErrors}" autocomplete="off" novalidate [formGroup]="pendingInfluencerForm">
            <div class="row">
              <div class="col-md-3">
                <div class="row">
                  <div class="col-7">
                    <div class="ir-form-field">
                      <achoo-filter-box #countrySelection
                                        class="ir-dropdown"
                                        name="pendingInfluencer.country"
                                        [options]="countries"
                                        [virtualScroll]="true"
                                        [(model)]="pendingInfluencer.country"
                                        (openDropDownEvent)="setActiveField(1)"
                                        (selectEvent)="getOfficialLanguage($event)"
                                        placeholder="{{'pending_influencer.country_placeholder' | translate}}">
                      </achoo-filter-box>
                    </div>
                  </div>

                  <div class="col-5 d-flex">
                    <div class="country-priority-container">
                      <span [attr.title]="pendingInfluencer.countryPriorityUserName">
                        <ng-container *ngIf="pendingInfluencer.countryPriority === 1">{{'influencer_review.country_priority.set_manually' | translate}}</ng-container>
                        <ng-container *ngIf="pendingInfluencer.countryPriority === 2">{{'influencer_review.country_priority.set_by_user' | translate}}</ng-container>
                        <ng-container *ngIf="pendingInfluencer.countryPriority === 3">{{'influencer_review.country_priority.set_by_admin' | translate}}</ng-container>
                        <ng-container *ngIf="pendingInfluencer.countryPriority === 4">{{'influencer_review.country_priority.set_by_analyst' | translate}}</ng-container>
                        <ng-container *ngIf="pendingInfluencer.countryPriority === 5">{{'influencer_review.country_priority.via_flag' | translate}}</ng-container>
                        <ng-container *ngIf="pendingInfluencer.countryPriority === 6">{{'influencer_review.country_priority.via_post_geo_tags' | translate}}</ng-container>
                        <ng-container *ngIf="pendingInfluencer.countryPriority === 7">{{'influencer_review.country_priority.via_phone_no' | translate}}</ng-container>
                      </span>
                    </div>
                  </div>

                </div>
                
                <div class="ir-form-field">
                  <achoo-filter-box #languageSelection
                                    class="ir-dropdown"
                                    name="pendingInfluencer.languages"
                                    [options]="languages"
                                    [virtualScroll]="true"
                                    [(model)]="pendingInfluencer.languages"
                                    (openDropDownEvent)="setActiveField(2)"
                                    placeholder="{{'pending_influencer.languages_placeholder' | translate}}">
                  </achoo-filter-box>
                </div>
                <div class="ir-form-field">
                  <achoo-filter-box #genderSelection
                                    class="ir-dropdown"
                                    name="pendingInfluencer.gender"
                                    [options]="genders"
                                    [(model)]="pendingInfluencer.gender"
                                    (openDropDownEvent)="setActiveField(3)"
                                    placeholder="{{'pending_influencer.gender_placeholder' | translate}}">
                  </achoo-filter-box>
                </div>
                <div class="form-fields first-form-row">
                  <div class="d-flex flex-column first-form-col">
                    <input #pendingInfluencerNameField
                           id="ir_field_4"
                           formControlName="name"
                           name="name"
                           type="text"
                           [(ngModel)]="pendingInfluencer.name"
                           (click)="setActiveField(4)"
                           placeholder="{{'pending_influencer.name_placeholder' | translate}}"
                           class="form-control" />
                  </div>
                  <div class="d-flex flex-column input-full-width">
                    <input id="ir_field_5"
                           formControlName="phone"
                           name="phone"
                           type="text"
                           [(ngModel)]="pendingInfluencer.phone"
                           (click)="setActiveField(5)"
                           placeholder="{{'pending_influencer.phone_placeholder' | translate}}"
                           class="form-control" />
                  </div>
                </div>
                <div class="form-fields">
                  <div class="d-flex flex-column first-form-col">
                    <input id="ir_field_6"
                           formControlName="email"
                           name="email"
                           type="email"
                           [(ngModel)]="pendingInfluencer.email"
                           (click)="setActiveField(6)"
                           placeholder="{{'pending_influencer.email_placeholder' | translate}}"
                           class="form-control" />
                  </div>
                </div>
              </div>
              <div class="col-md-9">
                <div class="row">
                  <div class="col-md-12 channel-item" *ngFor="let channel of pendingInfluencer.channels; trackBy: trackChannelFn; let i = index">
                    <div class="row">
                      <div class="col-md-2">
                        <div class="ir-form-field">
                          <achoo-filter-box class="ir-dropdown"
                                            id="ir_field_{{6 + i * 2 + 1}}"
                                            name="pendingInfluencerChannel{{channel.id > 0 ? channel.id : channel.index}}.platform"
                                            [options]="platforms"
                                            [(model)]="channel.platform_id"
                                            (selectEvent)="updateChannelLink(channel)"
                                            (openDropDownEvent)="setActiveField(6 + i * 2 + 1)"
                                            placeholder="{{'pending_influencer.platform_placeholder' | translate}}">
                          </achoo-filter-box>
                        </div>
                      </div>
                      <div class="col-md-5 d-flex">
                        <input required name="pendingInfluencerChannel{{channel.id > 0 ? channel.id : channel.index}}.handle" type="text"
                               id="ir_field_{{6 + i * 2 + 2}}"
                               placeholder="{{'pending_influencer.handle_placeholder' | translate}}"
                               [(ngModel)]="channel.handle"
                               (ngModelChange)="changeHandle($event, channel);"
                               (click)="setActiveField(6 + i * 2 + 2)" [ngModelOptions]="{standalone: true}"
                               class="form-control"
                               [ngClass]="{'error': channel.handle_error}"/>
                        <div class="channel-link-container">
                          <a *ngIf="channel.link" [attr.href]="channel.link" target="_blank">
                            <div class="{{channel.platformName + '-icon'}}"></div>
                          </a>
                        </div>
                      </div>
                      <div class="col-md-5">
                        <div class="source-id">
                          <input name="source_id_{{channel.id}}" type="text" disabled
                                 value="{{getSourceId(channel)}}" class="form-control"
                                 [ngClass]="{'error': hasSourceIdError(channel)}" />
                          <a class="icon-remove" (click)="deleteChannel(channel)">
                            <img src="assets/images/x-remove-icon.svg">
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="add-btn-container">
                      <button #AddNewChannelBtn id="AddNewChannelBtn" class="add-btn" (click)="addNewChannel()">
                        <img src="assets/images/Plus_Dark.svg" >
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </achoo-placeholder>
  <div class="inf-review-bottombar bottombar">
    <div class="buttons">
      <button #dismissInfluencerButton id="DismissInflButton"
              class="button lg-button red"
              [disabled]="isLoading || isDismissing || !pendingInfluencer"
              (click)="dismissInfluencer()">
        {{'common.btn.dismiss' | translate}}
      </button>
      <button #backButton
              class="button lg-button gray"
              [disabled]="isLoading || isDismissing || !pendingInfluencer"
              (click)="getPreviousInfluencer()">
        {{'common.btn.back' | translate}}
      </button>
      <button #nextButton
              class="button lg-button green" (click)="clickNext(nextButton)"
              [disabled]="isLoading || isDismissing || !pendingInfluencer">
        {{'common.btn.next' | translate}}
      </button>
    </div>
  </div>
</div>
<achoo-popup #ErrorWhenLoadingPendingInfluencer
             [isNotification]="true"
             modelTitle="{{'notification.error' | translate}}"
             (cancelCallback)="closeNotification()">
  <span>{{errorMessage}}</span>
</achoo-popup>
<achoo-popup #DeleteChannelWarning
             modelTitle="{{'pending_influencer.delete_channel_popup_title' | translate}}"
             [acceptBtnLabel]="'common.btn.accept' | translate"
             [cancelBtnLabel]="'common.btn.cancel' | translate"
             (acceptCallback)="onAcceptToDeleteChannel()"
             (cancelCallback)="closeDeleteChannelWarningPopup()">
  <span>{{'pending_influencer.confirm_to_delete_channel' | translate}}</span>
</achoo-popup>
<achoo-popup #PendingInfluencerSuccessNotification
             [isNotification]="true"
             modelTitle="{{'notification.success' | translate}}"
             (cancelCallback)="closeNotification()">
  <span [innerHTML]="'pending_influencer.update_success' | translate:{influencer_id: successCompletedInfluencer} "></span>
</achoo-popup>
<achoo-popup #SubmitInfluencerConfirmation
             modelTitle="{{'notification.warning' | translate}}"
             [acceptBtnLabel]="'common.btn.accept' | translate"
             [cancelBtnLabel]="'common.btn.cancel' | translate"
             (acceptCallback)="onAcceptToSubmitInfluencer()"
             (cancelCallback)="closeNotification()">
  <span>{{'pending_influencer.confirm_to_submit_influencer' | translate}}</span>
</achoo-popup>
<achoo-popup #DismissInfluencer (closeCallback)="closeDismissPopup()" [isSpecialPopup]="true">
  <dismiss-influencer-popup #dismissInfluencerPopupContent
                            (dismissInfluencer)="confirmDismissInfluencer($event)"
                            (closeDismiss)="closeDismissPopup()">
  </dismiss-influencer-popup>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/admin/influencer-review/influencer-review.component.html